import { axios } from '@/utils/request'
import { filterData } from '@/utils/util'
const api = {
  list: '/mcn/list',
  detail: '/mcn/detail',
  tips: '/mcn/tips',
  tipsV2:'/mcn/v2/tips', // 2023 0109 更新接口地址
  upload: '/mcn/upload',
  action: '/mcn/action',
  transcode:'/mcn/transcode',
  institutionList: '/ircs/institutionList',
  export:'/mcn/export'
}
// 查询内容素材审核列表
export function getMCNList(parameter) {
  return axios({
    url: api.list,
    method: 'get',
    params: filterData(parameter || {}),
    func:'查询内容素材审核列表'
  })
}
// 查询内容素材审核详情
export function getMCNDetail(parameter) {
  return axios({
    url: api.detail,
    method: 'get',
    params: parameter || {},
    func:'查询内容素材审核详情'
  })
}
// 查询待处理审核信息数
export function getMCNTips(parameter) {
  return axios({
    url: api.tipsV2,
    method: 'get',
    params: parameter || {},
    func:'查询待处理审核信息数'
  })
}
// 审核完成
export function saveAction(data={}) {
  return axios({
    url: api.action,
    method: 'post',
    data,
    headers: {
      'Content-Type':'application/json;utf-8'
    },
    func: data.stage===1?  '初审完成':'复审完成'
  })
}

// 视频转码
export function transcode(parameter) {
  return axios({
    url: api.transcode+'?id='+parameter.id,
    method: 'post',
    func:'视频转码'
  })
}

// 查询机构列表
export function getInstitutionList(params) {
  return axios({
    url: api.institutionList,
    method: 'get',
    params,
    func:'查询机构列表'
  })
}
// 导出
export function exportExcel(data={}) {
  return axios({
    url: api.export,
    method: 'post',
    responseType:'blob',
    data: data || {},
    headers: {
      'Content-Type':'application/x-www-form-urlencoded'
    },
    transformRequest: [data => {
      let ret = ''
      for(const it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
      }
      return ret
    }],
    func:'导出'
  })
}

